<template>
  <SkinnyBanner page="product" />
</template>

<script lang="ts" setup>
import SkinnyBanner from '~/scopes/branding/components/SkinnyBanner/SkinnyBanner.vue'
</script>
